import React from 'react'

export default function Footnote ({ color = '#737373', notes = [], omitPadding = false }) {
  return (
    <div className='row pb-5'>
      <div className='col-6 px-5 pt-5' />
      {notes.map(note => (
        <div
          key={note}
          className={`py-1 employees-subtext ${omitPadding ? '' : 'px-5'}`}
          style={{ color }}
        >
          {note}
        </div>
      ))}
    </div>
  )
}
